import reducer from "./reducers";

export { default as addressesOperations } from "./operations";

export default reducer
